import {FILTER_AVAILABILITY_SHOP_ID_LIST_CODE} from "../constants";
import Utils from "./Utils";

const AvailabilityFilterUtils = {

   filterAvailibilityValuesByShopCircle (availabilityFilterValues)  {

        const filterValues = availabilityFilterValues.filter(item => item[0] !== undefined)
        let shopCircleData = Utils.getShopCirleDataFromLocalStorage();
        let  filterValuesResult = filterValues
        if (shopCircleData["circleShops"]) {
            let shopCircleIds = []
            shopCircleData["circleShops"].forEach((shop) => {
                shopCircleIds.push(shop.id)
            });
            let availableFilterValues = filterValues.filter(filterValue => shopCircleIds.includes(filterValue[2]));
            let availabilityShopIdList = []
            availableFilterValues.forEach((filterValue) => {
                availabilityShopIdList.push(filterValue[2])
            });
            let unavailabilityShopList = shopCircleData["circleShops"].filter(item => !availabilityShopIdList.includes(item.id));
            let  unavailableFilterValues = []
            unavailabilityShopList.forEach((shop) => {
                unavailableFilterValues.push(this.prepareUnavailabilityShopId(shop))
            });
            const allFiltersValues = availableFilterValues.concat(unavailableFilterValues)
            const sortedFilterValues = this.sortFilterValuesByDistance(allFiltersValues, shopCircleIds);
            filterValuesResult = sortedFilterValues.slice(0, 4)
        }
       return filterValuesResult
    },
     prepareUnavailabilityShopId  (shop)  {
        let filterValueData = [FILTER_AVAILABILITY_SHOP_ID_LIST_CODE, shop.name , shop.id,'','','',false,'', 0, []]
        return filterValueData
    },
     sortFilterValuesByDistance (filterValues, circleShops)  {
        let filterValuesData = [];
        let sortedFilterValues = [];
        filterValues.forEach((filterValue) => {
            filterValuesData[filterValue[2]] = filterValue
        });
        circleShops.forEach((shop) => {
            sortedFilterValues.push(filterValuesData[shop])
        });
        return sortedFilterValues;
    }

}
export default AvailabilityFilterUtils;
